var map = {
	"./i_add-note.svg": "./assets/icons/i_add-note.svg",
	"./i_alert-octagon.svg": "./assets/icons/i_alert-octagon.svg",
	"./i_arrow-down--red.svg": "./assets/icons/i_arrow-down--red.svg",
	"./i_arrow-down--white.svg": "./assets/icons/i_arrow-down--white.svg",
	"./i_arrow-left--white.svg": "./assets/icons/i_arrow-left--white.svg",
	"./i_arrow-red.svg": "./assets/icons/i_arrow-red.svg",
	"./i_arrow-right--white.svg": "./assets/icons/i_arrow-right--white.svg",
	"./i_arrow-right.svg": "./assets/icons/i_arrow-right.svg",
	"./i_arrow-up--red.svg": "./assets/icons/i_arrow-up--red.svg",
	"./i_arrow-up--white.svg": "./assets/icons/i_arrow-up--white.svg",
	"./i_arrow.svg": "./assets/icons/i_arrow.svg",
	"./i_ban-solid.svg": "./assets/icons/i_ban-solid.svg",
	"./i_bell-01.svg": "./assets/icons/i_bell-01.svg",
	"./i_bell-regular.svg": "./assets/icons/i_bell-regular.svg",
	"./i_bookmark-full.svg": "./assets/icons/i_bookmark-full.svg",
	"./i_bookmark.svg": "./assets/icons/i_bookmark.svg",
	"./i_btn.svg": "./assets/icons/i_btn.svg",
	"./i_checked.svg": "./assets/icons/i_checked.svg",
	"./i_chip.svg": "./assets/icons/i_chip.svg",
	"./i_circle-exclamation-solid.svg": "./assets/icons/i_circle-exclamation-solid.svg",
	"./i_circle-question-regular.svg": "./assets/icons/i_circle-question-regular.svg",
	"./i_clipboard-regular.svg": "./assets/icons/i_clipboard-regular.svg",
	"./i_clock-stopwatch.svg": "./assets/icons/i_clock-stopwatch.svg",
	"./i_close.svg": "./assets/icons/i_close.svg",
	"./i_comments-regular.svg": "./assets/icons/i_comments-regular.svg",
	"./i_copy.svg": "./assets/icons/i_copy.svg",
	"./i_cross.svg": "./assets/icons/i_cross.svg",
	"./i_download.svg": "./assets/icons/i_download.svg",
	"./i_edit.svg": "./assets/icons/i_edit.svg",
	"./i_email.svg": "./assets/icons/i_email.svg",
	"./i_file-check-02.svg": "./assets/icons/i_file-check-02.svg",
	"./i_level-pointer.svg": "./assets/icons/i_level-pointer.svg",
	"./i_linkedin.svg": "./assets/icons/i_linkedin.svg",
	"./i_logo-old.svg": "./assets/icons/i_logo-old.svg",
	"./i_logo.svg": "./assets/icons/i_logo.svg",
	"./i_logout.svg": "./assets/icons/i_logout.svg",
	"./i_menu.svg": "./assets/icons/i_menu.svg",
	"./i_message-notification-square.svg": "./assets/icons/i_message-notification-square.svg",
	"./i_message-question-square.svg": "./assets/icons/i_message-question-square.svg",
	"./i_pdf-download.svg": "./assets/icons/i_pdf-download.svg",
	"./i_pin.svg": "./assets/icons/i_pin.svg",
	"./i_play.svg": "./assets/icons/i_play.svg",
	"./i_plus.svg": "./assets/icons/i_plus.svg",
	"./i_print.svg": "./assets/icons/i_print.svg",
	"./i_profile.svg": "./assets/icons/i_profile.svg",
	"./i_remove.svg": "./assets/icons/i_remove.svg",
	"./i_reset.svg": "./assets/icons/i_reset.svg",
	"./i_search-black.svg": "./assets/icons/i_search-black.svg",
	"./i_search-red.svg": "./assets/icons/i_search-red.svg",
	"./i_search.svg": "./assets/icons/i_search.svg",
	"./i_selected.svg": "./assets/icons/i_selected.svg",
	"./i_settings.svg": "./assets/icons/i_settings.svg",
	"./i_star-full.svg": "./assets/icons/i_star-full.svg",
	"./i_star.svg": "./assets/icons/i_star.svg",
	"./i_tick.svg": "./assets/icons/i_tick.svg",
	"./i_time.svg": "./assets/icons/i_time.svg",
	"./i_tip.svg": "./assets/icons/i_tip.svg",
	"./i_tools.svg": "./assets/icons/i_tools.svg",
	"./i_turkey.svg": "./assets/icons/i_turkey.svg",
	"./i_twitter.svg": "./assets/icons/i_twitter.svg",
	"./i_write-email.svg": "./assets/icons/i_write-email.svg",
	"./i_xlsx-download.svg": "./assets/icons/i_xlsx-download.svg",
	"./i_youtube.svg": "./assets/icons/i_youtube.svg",
	"./i_youtube_corpFill.svg": "./assets/icons/i_youtube_corpFill.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/icons sync recursive ^\\.\\/i_.*\\.svg$";